import type { ButtonHTMLAttributes } from "react";
import { cn } from "./cn";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "ghost" | "danger";
  size?: "default" | "compact" | "icon";
};

export function Button({ className, size = "default", variant = "secondary", type = "button", ...props }: ButtonProps) {
  return <button type={type} className={cn("button", `button--${variant}`, `button--${size}`, className)} {...props} />;
}
